// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__JRQuE","crumb":"styles_crumb__RAMYz","label":"styles_label__QQidB","icon":"styles_icon__k29C5"};